import { gql } from "@apollo/client";
import { PodcastBaseFragment } from "../../fragments/podcast";

export const QUERY_FETCH_LATEST_KNOWLEDGE_BASE = gql`
  query fetchLatestKnowledgeBaseForHome {
    knowledgeBases: knowledgeBases_connection(
      pagination: { limit: 1 }
      sort: "publicationDate:desc"
      filters: { publishedAt: { notNull: true } }
    ) {
      nodes {
        documentId
        title
        slug
        briefDescription
        publicationDate
        knowledgeBaseType {
          documentId
          type
        }
        cover {
          url
          alternativeText
          mime
        }
      }
    }
  }
`;

export const QUERY_FETCH_LATEST_PODCAST = gql`
  query fetchLatestPodcastForHome($userDocumentId: ID!) {
    podcasts: podcasts_connection(
      pagination: { limit: 1 }
      sort: "publicationDate:desc"
      filters: { publishedAt: { notNull: true } }
    ) {
      nodes {
        ...PodcastBaseFragment
        listenings(
          filters: { staff: { documentId: { eq: $userDocumentId } } }
        ) {
          documentId
          listeningTime
          duration
        }
      }
    }
  }
  ${PodcastBaseFragment}
`;
